import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValues = {
  showTimeSeries: false,
};

const usePanelStore = create()(immer(() => initialValues));

const { setState: set } = usePanelStore;

export const panelActions = {
  toggleTimeSeries: () =>
    set(state => {
      state.showTimeSeries = !state.showTimeSeries;
    }),
};

export const useShowTimeSeries = () => usePanelStore(store => store.showTimeSeries);

export default usePanelStore;
